import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function FacebookImportDialog({
  open, onOpenChange, onImported,
}:{
  open:boolean; onOpenChange:(v:boolean)=>void;
  onImported:(data:{ url?:string; title?:string; details?:string; startIso?:string; endIso?:string })=>void;
}) {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  async function handle() {
    if (!url) return;
    setLoading(true);
    try {
      // Later: call your HTTPS callable to parse OG tags server-side
      onImported({ url });
      onOpenChange(false);
    } finally { setLoading(false); }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Import from Facebook</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Input placeholder="Paste Facebook event URL" value={url} onChange={e=>setUrl(e.target.value)} />
          <div className="text-xs text-indigo-200">We’ll pull title/time/cover if available. You can tweak after.</div>
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={()=>onOpenChange(false)}>Cancel</Button>
            <Button onClick={handle} disabled={!url || loading}>{loading?"Importing...":"Import"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

